import { api } from './client';
import { createResourceCache } from './cache/resourceCache';
import type { DoctorProfile } from '@/types/auth';

const doctorProfileCache = createResourceCache<DoctorProfile>();

type DoctorProfileResponse = DoctorProfile & {
  password?: string;
};

export function clearDoctorProfileCache(): void {
  doctorProfileCache.clear();
}

export async function getDoctorProfile(
  forceRefresh = false
): Promise<DoctorProfile> {
  if (!forceRefresh) {
    const cached = doctorProfileCache.get();
    if (cached) {
      return cached;
    }

    const pending = doctorProfileCache.getPending();
    if (pending) {
      return pending;
    }
  }

  const request = api
    .get<DoctorProfileResponse>('/doctor/profile/')
    .then((data) => {
      const { password: _password, ...profile } = data;
      doctorProfileCache.set(profile);
      return profile;
    })
    .catch((error) => {
      doctorProfileCache.setPending(null);
      throw error;
    });

  doctorProfileCache.setPending(request);
  return request;
}
